import { Injectable } from '@angular/core';
import { ElementOf } from '../../../../../../common/model/types/element-of.type';
import { Breadcrumb } from './model/breadcrumb.model';

@Injectable({providedIn: 'root'})
export class BreadcrumbService {
    breadcrumb: Breadcrumb = [];

    add(breadcrumbItem: ElementOf<Breadcrumb>): void {
        this.breadcrumb = [...this.breadcrumb, {...breadcrumbItem}];
    }
}
